<!--Success screen-->
<div
  class="
    col-xs-12 col-sm-12 col-md-12
    Registration-split
    recovery-split
    border-align
  "
  >
  <h3 class="login-help-title">
    {{ "passwordRecoveryFailure.passwordLinkInfoMessage" | cxTranslate }}
  </h3>
  <div class="col-xs-12 col-sm-8 col-md-8 p0">
    <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
      <label class="Fields-label">{{
        "forgotUserPassword.emailAddress" | cxTranslate
      }}</label>
      <span class="recovery-common-txt">{{ userAgentData?.email }}</span>
    </div>
  </div>
  <hr class="Fields-container-line" />
  <span class="recovery-common-txt">
    If the email address listed here is not correct,
    <b>please try again with correct email address.</b> <br /><br />
    If you do not receive an email within 30 minutes, please check your spam
    folder, or call @if (baseSiteId == 'vsh') {
    <span>1-800-VACCINE (1-800-822-2463)</span>
    }@if (baseSiteId == 'vax') {
    <span>1-800-752-9338</span>
    } for assistance.
  </span>
</div>
